import * as React from 'react';

import { useIsMounted } from 'bones/utils/hooks/useIsMounted';

export const useWithLoading = (name: string) => {
  const isMounted = useIsMounted();

  return React.useCallback(
    async <T>(
      setLoading: (loading: boolean) => void,
      callback: () => Promise<T>
    ): Promise<T | null> => {
      let result: T | null = null;

      if (!isMounted.current) {
        return result;
      }

      setLoading(true);

      try {
        result = await callback();
      } catch (e) {
        console.warn(`useWithLoading ${name} failed: `, e);
      }

      if (!isMounted.current) {
        return result;
      }

      setLoading(false);
      return result;
    },
    [isMounted, name]
  );
};
